type LintrkWindow = Window & {
  lintrk?: (action: string, data: { conversion_id: number }) => void;
};

export const trackSignUp = () => {
  if (typeof window === "undefined") return;
  const { lintrk } = window as LintrkWindow;
  if (lintrk) {
    lintrk("track", { conversion_id: 26758001 });
  }
};
